export default "<div class=\"tabs-shell-container\">\n\n    <ion-content fullscreen>\n        <ng-content></ng-content>\n    </ion-content>\n\n</div>\n";